export enum PointsReportType {
  NETTO_AND_BRUTTO_POINTS = "NETTO_AND_BRUTTO_POINTS",
  NETTO_POINTS = "NETTO_POINTS",
  BRUTTO_POINTS = "BRUTTO_POINTS"
}
